import { GraphSchema } from '@camelot/server';
import { User } from '@camelot/user';

import { CalendarEntry, calendarEntryProps } from './calendar-entry';
import { NoteType } from './note-type';

export interface CalendarNote extends CalendarEntry {
  userId: string;
  user?: User;
  noteType: NoteType;
}

const props: (keyof CalendarNote)[] = ['userId', 'user', 'noteType'];

export const calendarNoteProps = new GraphSchema<CalendarNote>(props.concat(calendarEntryProps));
